<template>
  <div class="box">
    <div>
      <input
        type="text"
        class="inputSet"
        v-model="cityInput"
        @click="clkInput"
        @input="inputBtn(cityInput)"
        ref="refPickupCity"
        @focus="focusInput"
        :class="isRed ? 'borRed input_place' : ''"
        :placeholder="placeholdertext"
        @change="chgInput"
        @blur="blurInput"
      />
    </div>

    <div id="pickupCityId" class="cityBox" v-if="bigBox">
      <div class="cityTitle" v-if="showText !== 4">
        <a :class="showText == 1 ? 'pitchOn' : ''" @click="clkTitleBtn(1)"
          >Favorite city</a
        >
        <a
          class="nowrapText"
          :class="showText == 2 ? 'pitchOn' : ''"
          @click="clkTitleBtn(2)"
          >{{ ProvinceText }}</a
        >
        <a :class="showText == 3 ? 'pitchOn' : ''" v-if="showSelectCity"
          >Select</a
        >
        <a
          class="nowrapText"
          :class="showText == 3 ? 'pitchOn' : ''"
          @click="clkTitleBtn(3)"
          >{{ CityText }}</a
        >
      </div>

      <ul class="cityText1" v-if="showText == 1">
        <li
          v-for="(item, index) in pickupCityData"
          :key="index"
          @click.stop="clkCityText(item)"
        >
          {{ item.NameEn }}
        </li>
      </ul>
      <ul class="cityText1" v-if="showText == 2">
        <li
          v-for="(item, index) in pickupProvData"
          :key="index"
          @click.stop="clkPro(item)"
        >
          {{ item.Province.Province_NameEn }}
        </li>
      </ul>
      <ul class="cityText1" v-if="showText == 3">
        <li
          v-for="(info, index) in pickupAreaData"
          :key="index"
          @click.stop="clkCitySelect(info)"
        >
          {{ info.City_NameEn }}
        </li>
      </ul>
      <ul class="searchText" v-if="showText == 4">
        <li
          v-for="(item, index) in searchData1"
          :key="index"
          @click="clkSearchText(item)"
          v-if="searchData1.length > 0"
        >
          <span v-if="item.CityList.length > 1">{{
            item.Province.Province_NameEn
          }}</span>
          <span
            v-for="info in item.CityList"
            :key="info.Id"
            v-if="item.CityList.length == 1"
            >{{ info.City_NameEn }}-{{ item.Province.Province_NameEn }}</span
          >

          <!-- //<span>{{item.Province.Province_NameCh}}</span>//
           //<span v-for="info in item.CityList" :key="info.Id" v-if="item.CityList.length==1">-{{info.City_NameCh}}</span>// -->
        </li>
        <li v-if="searchData1.length <= 0">
          <span class="colRed">No result</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
//引入axios
import { fetch, post } from "../../../ask/axios";
import bus from "@/ask/eventBus";
import { getCookie } from "@/ask/cookiejs";

const cargoItemOptions = [];
export default {
  props: {
    //      titNames:'',
    //      titUrls:''
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },

      placeholdertext: "",
      isRed: false, //是否显示红色的线提示为空

      cityInput: "",
      bigBox: false,
      ProvinceText: "Province",
      CityText: "",
      bigBox2: false,

      //提货常用城市
      pickupCityData: [],
      pickupProvData: [],
      pickupAreaData: [],

      searchData1: [],

      showText: 1,
      showSelectCity: false,

      //省份数据保存
      ProvDate: { ProvNameEn: "", ProvNameCh: "", ProvKey: "" },
      ProvDateBf: { ProvNameEn: "", ProvNameCh: "", ProvKey: "" },
      CityDate: { CityNameEn: "", CityNameCh: "", CityKey: "" },
      isSearch: false, // 是否正在搜索
      pickupAllCity: [], // 所有城市列表
    };
  },

  created() {
    //货物地址栏上的参数赋值到起运城市中

    if (this.$route.query.startProNameEn && this.$route.query.startCityNameEn) {
      this.cityInput =
        this.$route.query.startProNameEn +
        "/" +
        this.$route.query.startCityNameEn;

      //保存数据
      this.CityDate.CityNameEn = this.$route.query.startCityNameEn;
      this.CityDate.CityKey = this.$route.query.StartCityKey;
      this.CityDate.CityNameCh = this.$route.query.startCityNameCh;
      this.ProvDate.ProvNameEn = this.$route.query.startProNameEn;
      this.ProvDate.ProvNameCh = this.$route.query.startProNameEn;

      this.ProvDateBf.ProvNameEn = this.ProvDate.ProvNameEn;
      this.ProvDateBf.ProvNameCh = this.ProvDate.ProvNameCh;
    }
  },
  mounted() {
    //点击其他区域关闭自定义div
    document.addEventListener("click", (e) => {
      // if(this.bigBox){
      //   // var sp = document.getElementById("pickupCityId");
      //   // if(sp && !sp.contains(e.target)) {
      //   //   this.bigBox=false
      //   // }

      if (!this.$el.contains(e.target)) {
        this.bigBox = false; //点击其他区域关闭
      } else {
        this.bigBox = true;
      }
    });

    this.getThHotCityApi(); //常用市接口
    this.getProvDataApi(); //省市区接口
  },
  methods: {
    //点击input自动选中里面的值
    focusInput: function (e) {
      this.$refs.refPickupCity.select(); // or e.currentTarget.select();
    },
    //输入没有选择下拉，清除输入框中值
    blurInput() {
      if (!this.CityDate.CityKey) {
        this.cityInput = "";
      }
    },

    //点击 input 弹出下拉框
    clkInput() {
      this.bigBox = true;
      this.showText = 1;
      this.showSelectCity = false;
      this.ProvinceText = "Province";
    },
    inputBtn(text) {
      let isShow = 2;
      let take = 10;
      let patrn = /^[^\u4E00-\u9FA5]+$/;
      if (patrn.test(text) && text.length >= 4) {
        this.getProvDataApi(isShow, text, take);
      } else {
        this.clkInput();
      }

      (this.CityDate.CityNameEn = ""),
        (this.CityDate.CityKey = ""),
        (this.CityDate.CityNameCh = ""),
        (this.ProvDate.ProvNameCh = ""),
        this.sentMsgToService();
    },

    clkTitleBtn(k) {
      //点击标题，进行切换常用城市、省、市
      this.showText = k;
      if (k == 1) {
        this.CityText = "";
        this.showSelectCity = false;
      }
      if (k == 2) {
        this.CityText = "";
        this.ProvinceText = "Province";
      }
    },
    clkCityText(item) {
      //选中常用城市
      //console.log('item '+ JSON.stringify(item));
      this.cityInput = item.Province_NameEn + "/" + item.NameEn;

      //保存数据
      this.CityDate.CityNameEn = item.NameEn;
      this.CityDate.CityKey = item.CityKey;
      this.CityDate.CityNameCh = item.NameCh;
      this.ProvDate.ProvNameEn = item.Province_NameEn;
      this.ProvDate.ProvNameCh = item.Province_NameCh;
      //ProvDate:{ProvNameEn:'',ProvNameCh:'',ProvKey:'',},

      this.ProvDateBf.ProvNameEn = this.ProvDate.ProvNameEn;
      this.ProvDateBf.ProvNameCh = this.ProvDate.ProvNameCh;
      //console.log('item '+ JSON.stringify(this.ProvDate.ProvNameCh));

      this.sentMsgToService();
      this.chgInput();

      this.bigBox = false;
    },
    clkPro(item) {
      //选择省份
      //console.log('item '+ JSON.stringify(item.CityList));
      this.showSelectCity = true;
      this.ProvinceText = item.Province.Province_NameEn;

      //保存数据
      this.ProvDate.ProvNameEn = item.Province.Province_NameEn;
      this.ProvDate.ProvNameCh = item.Province.Province_NameCh;
      //选择省份后市区赋值
      this.pickupAreaData = item.CityList;

      this.showText = 3;
    },
    clkCitySelect(item) {
      //选择城市

      this.cityInput = this.ProvDate.ProvNameEn + "/" + item.City_NameEn;

      //保存数据
      this.CityDate.CityNameEn = item.City_NameEn;
      this.CityDate.CityKey = item.Id;
      this.CityDate.CityNameCh = item.City_NameCh;

      this.ProvDateBf.ProvNameEn = this.ProvDate.ProvNameEn;
      this.ProvDateBf.ProvNameCh = this.ProvDate.ProvNameCh;

      this.sentMsgToService();
      this.chgInput();
      this.bigBox = false;
    },
    //搜索点击
    clkSearchText(item) {
      if (item.CityList.length == 1) {
        item.CityList.forEach((k) => {
          //保存数据
          this.ProvDate.ProvNameEn = item.Province.Province_NameEn;
          this.ProvDate.ProvNameCh = item.Province.Province_NameCh;

          this.ProvDateBf.ProvNameEn = this.ProvDate.ProvNameEn;
          this.ProvDateBf.ProvNameCh = this.ProvDate.ProvNameCh;

          this.CityDate.CityNameEn = k.City_NameEn;
          this.CityDate.CityKey = k.Id;
          this.CityDate.CityNameCh = k.City_NameCh;

          this.cityInput =
            this.ProvDate.ProvNameEn + "/" + this.CityDate.CityNameEn;
          this.bigBox = false;
        });
      } else if (item.CityList.length > 1) {
        this.pickupAreaData = item.CityList;

        this.ProvinceText = item.Province.Province_NameEn;
        this.CityText = "";
        this.showSelectCity = true;

        this.showText = 3;

        //保存数据
        this.ProvDate.ProvNameEn = item.Province.Province_NameEn;
        this.ProvDate.ProvNameCh = item.Province.Province_NameCh;
      }

      this.sentMsgToService();
    },

    //===========子组件传值到父组件=============//
    sentMsgToService() {
      let str = {
        StartCityNameEn: this.CityDate.CityNameEn,
        StartCityKey: this.CityDate.CityKey,
        StartCityNameCh: this.CityDate.CityNameCh,
        StartProvNameCh: this.ProvDateBf.ProvNameCh,
        StartProvNameEn: this.ProvDateBf.ProvNameEn,
      };

      this.$emit("sentStartMsgSev", str);
    },

    //===========接口=============//

    //常用市区接口
    getThHotCityApi() {
      let that = this;
      this.api.param = {};
      // this.api.url=this.$api01+"/api/InfoCustomer/Attribute/QueryThHotCity"
      this.api.url = this.$api04 + "/Basics/api/Attribute/QueryThHotCity";
      fetch(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK) {
          that.pickupCityData = res.Results;
        }
      });
    },

    //省市区接口
    getProvDataApi(searchShow, text, take) {
      let that = this;
      if (searchShow == 2) {
        this.api.param = {
          name: text,
          take: take,
          sysInfo: 1, //0:中文，1：英文
        };
      } else {
        this.api.param = {};
      }
      // this.api.url=this.$api02+"/api/EbayCustomer/Province/QueryProvinceAndCity"
      this.api.url =
        this.$api04 + "/Basics/api/SysRegion/QueryAllProvinceAndCity";
      fetch(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK) {
          for (let i = 0; i < res.Results.length; i++) {
            let cityList = res.Results[i]["CityList"];
            let province = res.Results[i]["Province"];
            for (let j = 0; j < cityList.length; j++) {
              that.$set(cityList[j], "Id", cityList[j]["City_Key"]);
              let areaList = cityList[j].AreaList;

              for (let n = 0; n < areaList.length; n++) {
                that.$set(areaList[n], "Id", areaList[n]["CityArea_Key"]);
              }
            }
            for (let j = 0; j < province.length; j++) {
              that.$set(province[j], "Id", province[j]["Province_Key"]);
            }
          }
          if (searchShow == 2) {
            //搜索
            that.showText = 4;
            that.searchData1 = res.Results;
          } else {
            that.pickupProvData = res.Results;
            that.searchData1 = [];
          }
        }
      });
    },

    //如果为空  提示
    showTips() {
      if (!this.cityInput) {
        this.placeholdertext = "Required";
        this.isRed = true;
      }
    },
    //关闭提示
    hiddenTips() {
      this.placeholdertext = "";
      this.isRed = false;
    },

    chgInput() {
      if (this.cityInput) {
        this.placeholdertext = "";
        this.isRed = false;
      }
    },
  },
};
</script>
<style lang="css" scoped>
.box {
  position: relative;
}
.inputSet {
  width: 90%;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 5px;
}
.cityBox {
  width: 450px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
  position: absolute;
  z-index: 99;
  overflow: hidden;
}
.cityTitle {
  height: 35px;
  border-bottom: 1px solid #ddd;
  line-height: 35px;
}
.cityTitle a {
  display: inline-block;
  width: 33.33%;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  float: left;
}
.pitchOn {
  background: #004fb1;
  color: white;
}

.cityText1 {
  padding: 5px;
  overflow: auto;
  min-height: 120px;
  display: black;
}
.cityText1 li {
  float: left;
  width: 25%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cityText1 li:hover {
  background: #f5f5f5;
}

.searchText li {
  padding: 3px 10px;
  cursor: pointer;
}
.searchText li:hover {
  background: #0c5ee4;
  color: #fff;
}

.nowrapText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
 


// WEBPACK FOOTER //
// src/components/userCenter/public/pickupStartCity.vue